import { View, useWindowDimensions, ScrollView } from 'react-native';

import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import RenderHTML from 'react-native-render-html';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export default function ConsentModalContent({ consentText }) {
  const fontSize = useResponsiveFontSize(1.5);
  const { width: contentWidth } = useWindowDimensions();
  const customStyles = {
    body: {
      fontSize,
      lineHeight: 40,
      color: colors.newUI.therapist.textBlue100,
    },
    strong: {
      fontSize,
      fontWeight: 'bold',
      lineHeight: 40,
      color: colors.newUI.therapist.textBlue100,
    },
    p: {
      fontSize,
      lineHeight: 40,
      marginBottom: 16,
      color: colors.newUI.therapist.textBlue100,
    },
  };

  return (
    <View style={IS_WEB ? { flex: 1 } : { maxHeight: '90%' }}>
      <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
        <RenderHTML
          tagsStyles={customStyles}
          contentWidth={contentWidth}
          source={{ uri: consentText }}
        />
      </ScrollView>
    </View>
  );
}
